__webpack_require__.p = "/book_recommendation_frontend/";